require("core-js/modules/es6.object.assign");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.reduce");

function r(r) {
  return r && "object" == typeof r && "default" in r ? r["default"] : r;
}

var e = require("react"),
    t = r(e),
    n = r(require("prop-types")),
    o = r(require("katex"));

function s(r) {
  var e,
      n,
      s = (e = ["children", "math", "block", "errorColor", "renderError", "settings"], n = r, Object.keys(n).reduce(function (r, t) {
    return e.includes(t) ? r : (r[t] = n[t], r);
  }, {})),
      c = r.block ? "div" : "span",
      i = r.children || r.math;

  try {
    var a = o.renderToString(i, Object.assign({}, {
      displayMode: !!r.block,
      errorColor: r.errorColor,
      throwOnError: !!r.renderError
    }, r.settings));
    return t.createElement(c, Object.assign({}, s, {
      dangerouslySetInnerHTML: {
        __html: a
      }
    }));
  } catch (e) {
    if (e instanceof o.ParseError || e instanceof TypeError) return r.renderError ? r.renderError(e) : t.createElement(c, Object.assign({}, s, {
      dangerouslySetInnerHTML: {
        __html: e.message
      }
    }));
    throw e;
  }
}

s.propTypes = {
  children: n.string,
  math: n.string,
  block: n.bool,
  errorColor: n.string,
  renderError: n.func,
  settings: n.object
};
var c = e.memo(s);
module.exports = c;